// extracted by mini-css-extract-plugin
export var statItem = "_m8-1";
export var statsRow = "_m8-0";